import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Segment, Dimmer, Loader, Button, Header, Message } from 'semantic-ui-react';

import {
  SG_FETCH_ACTION_TEMPLATE,
  SG_DELETE_ACTION_TEMPLATE,
} from "constants/actions";

const ActionTemplateDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(false);

  const template = useSelector((state) => 
    state.action_template?.[id] || null
  );

  useEffect(() => {
    if (id) {
      setLoading(true);
      dispatch({
        type: SG_FETCH_ACTION_TEMPLATE,
        payload: { id }
      });
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (template) {
      setLoading(false);
    }
  }, [template]);

  const handleEdit = () => {
    navigate(`../edit/${id}`);
  };

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this action template?')) {
      setDeleting(true);
      dispatch({
        type: SG_DELETE_ACTION_TEMPLATE,
        payload: id
      });
      // Navigate back after deletion
      setTimeout(() => {
        navigate('../');
      }, 1000);
    }
  };

  const handleBack = () => {
    navigate('../');
  };

  if (loading) {
    return (
      <Segment>
        <Dimmer active>
          <Loader>Loading action template...</Loader>
        </Dimmer>
      </Segment>
    );
  }

  if (!template) {
    return (
      <Message error>
        <Message.Header>Template Not Found</Message.Header>
        <p>The requested action template could not be found.</p>
        <Button onClick={handleBack}>Back to Templates</Button>
      </Message>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: '1rem' }}>
        <Button onClick={handleBack}>← Back to Templates</Button>
        <Button primary onClick={handleEdit} style={{ marginLeft: '0.5rem' }}>
          Edit Template
        </Button>
        <Button 
          negative 
          onClick={handleDelete} 
          loading={deleting}
          style={{ marginLeft: '0.5rem' }}
        >
          Delete Template
        </Button>
      </div>

      <Header as="h2">
        {template.name || `Action Template ${template.id}`}
      </Header>

      <Segment>
        <Header as="h3">Template Details</Header>
        <div style={{ marginBottom: '1rem' }}>
          <strong>ID:</strong> {template.id}
        </div>
        
        {template.name && (
          <div style={{ marginBottom: '1rem' }}>
            <strong>Name:</strong> {template.name}
          </div>
        )}
        
        {template.description && (
          <div style={{ marginBottom: '1rem' }}>
            <strong>Description:</strong> {template.description}
          </div>
        )}
        
        {template.created_at && (
          <div style={{ marginBottom: '1rem' }}>
            <strong>Created:</strong> {new Date(template.created_at).toLocaleDateString()}
          </div>
        )}
        
        {template.updated_at && (
          <div style={{ marginBottom: '1rem' }}>
            <strong>Last Updated:</strong> {new Date(template.updated_at).toLocaleDateString()}
          </div>
        )}
      </Segment>

      {template.content && (
        <Segment>
          <Header as="h3">Template Content</Header>
          <div style={{ whiteSpace: 'pre-wrap' }}>
            {template.content}
          </div>
        </Segment>
      )}
    </div>
  );
};

export default ActionTemplateDetails;
